import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function DiceSVG({ className = 'w-16 h-16' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="18" height="18" rx="6" className="fill-royal/30 stroke-royal" strokeWidth="2"/>
      <circle cx="8" cy="8" r="2" className="fill-gold"/>
      <circle cx="16" cy="16" r="2" className="fill-gold"/>
    </svg>
  );
}

export default function WelcomePopup({ duration = 3500 }) {
  const [open, setOpen] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setOpen(false), duration);
    return () => clearTimeout(t);
  }, [duration]);
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[100] grid place-items-center backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 200, damping: 20 }}
            className="rounded-2xl p-8 text-center bg-white/10 border border-white/20 shadow-soft"
          >
            <motion.div
              animate={{ rotate: [0, 360] }}
              transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
              className="mx-auto mb-4"
            >
              <DiceSVG />
            </motion.div>
            <h3 className="text-white text-xl font-bold mb-1">Welcome!</h3>
            <p className="text-white/80">Rolling the dice… get ready.</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

